var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-subtitle-1 font-weight-medium text-uppercase primary-font-color--text",attrs:{"data-testid":"group-header"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }